<template>
    <base-layout>
        <!-- 组件 -->
        <download-bar/>
        <!-- START -->
        <div class="section banner">
            <!-- 返回按钮 -->
            <a class="btn btn-back" href="/">
                <i class="iconfont icon-back"></i>
            </a>
        </div>
        <!-- 资讯 -->
        <div class="section news">
            <div class="section-content">
                <news-list :count='10' ref="list" @changePage="setPageNum"></news-list>
            </div>
        </div>
        <!-- 资讯分页 -->
        <div class="section news-ctrl">
            <div class="section-content">
                <div class="btns">
                    <button @click="loadMore(-1)">&lt;</button>
                    <button class="page">{{ page }}</button>
                    <button @click="loadMore(1)">&gt;</button>
                </div>
            </div>
        </div>
        <site-footer/>        
    </base-layout>
</template>

<script>


export default {
    name: 'NewsMobile',
    data () {
        return {
            page: 1
        }
    },
    components: {
        SiteFooter: () => import('components/SiteFooter'),
        DownloadBar: () => import('components/DownloadBar'),
        NewsList: () => import('components/NewsList'),
    },
    computed: {
        list () {
            return this.$refs.list
        }
    },
    methods: {
        loadMore (arr) {
            this.list.setPage(arr)
        },
        setPageNum (page) {
            this.page = page
        }
    }
}
</script>

<style lang="scss" src="~/scss/mobile.scss"></style>
<style lang="scss" src="~/scss/news.mobile.scss"></style>